<div class="w-12 cursor-pointer flex flex-middle"
     [toggle]="['multisite-switch', 0]"
     [toggleClass]="'is-open'">
    <multisite-flag class="m-r-1-x m-r-1-l p-t-1-l p-t-1-x"
                    [country]="current.country" />
    <p class="p1 m-l-5-m m-l-5-s">{{current.name}}&nbsp;{{current.currency}}</p>
    <i class="flex-m flex-s p-l-1 p-t-1-l p-t-1-x icon-down col-11"
       aria-hidden="true"
       [toggleClass]="'!icon-down icon-up'"
       [toggleClassBy]="['multisite-switch', 0]"></i>
</div>
<div [hideUp]="['multisite-switch', 0]">
    <div class="bg-col-w b-a">
        @for (item of all; track $index) {
        <a class="cursor-pointer flex flex-middle flex-justify-left p-a-2 p1"
           [attr.href]="getRedirectLink($any(item)) || $any(item).url"
           (click)="goTo($any(item), $event)">
            <!-- current.country -->
            <multisite-flag class="m-r-1 flex flex-middle"
                            [country]="item.country" />
            {{item.name}}&nbsp;({{item.currency}})
        </a>
        }
    </div>
</div>